import { Sector } from '@/types/types';

export const sectors: Sector[] = [
	{
		id: 'af23d67a-1c3e-49e4-8c72-4f3bd5f4a30b',
		name: 'Alkoholische Getränke, Spirituosen',
	},
	{
		id: 'ed5932cb-2e48-4f18-8467-5c6c9fb9dbf6',
		name: 'Banken, Versicherungen, Kreditwesen',
	},
	{
		id: '9e7f6a5e-4db1-438a-87a5-9e7b91514b1b',
		name: 'Bekleidung, Textilien',
	},
	{
		id: 'd4a3f94b-d920-4f4c-9b74-79f6254f0db8',
		name: 'Bücher, Zeitschriften, Magazine',
	},
	{
		id: '5b6a723c-7d2e-4920-8f28-0d2c7fc0d7b4',
		name: 'Bundesministerium',
	},
	{
		id: 'cfa2b2a5-b3f7-48f5-a5b0-d6b7bfb3a7e8',
		name: 'Chemisch-pharmazeutische Produkte',
	},
	{
		id: '29c1e2f7-1588-4df9-8cb6-3f8e1f674c52',
		name: 'derzeit unbekannt',
	},
	{
		id: 'dd714c56-29f3-4d0e-8d41-7b3d8a6a9c5a',
		name: 'Druckerei, Verlag, Repro',
	},
	{
		id: 'be2a0bfa-55b2-4c9e-abe7-43c5c03d8365',
		name: 'EDV, Telekommunikation',
	},
	{
		id: '6e9c2c4f-8d2b-4e98-81f6-f63e5b1d3f43',
		name: 'Einrichtungsgegenstände, Möbel',
	},
	{
		id: 'f1c431a7-fd43-4e8a-9bfa-75f0bfc8df55',
		name: 'Elektro- und Sanitärinstallation',
	},
	{
		id: 'ebd2a2e9-6c3a-4f3a-b9e2-2d6a2a6b9e3f',
		name: 'Elektrogeräte, Unterhaltungselektronik',
	},
	{
		id: 'b762ae68-1b4a-4f8e-839d-43d5b6c7a62d',
		name: 'Erotik-Artikel',
	},
	{
		id: '4e3d24c3-7b8e-4d48-8e3d-2b6a3a8c9f6e',
		name: 'Events, Veranstaltungen',
	},
	{
		id: 'f4b7a2e3-6b7f-4f5b-8e4c-6d7b3e8c7e5a',
		name: 'Freizeit',
	},
	{
		id: '9e6b7a5e-7d4f-4f7a-8d3e-3e8b9e5c2a7f',
		name: 'Gastronomie',
	},
	{
		id: 'a4c2d7e8-5b2e-4e7c-8f4d-4b7a2e9f5c6a',
		name: 'Gemeinde',
	},
	{
		id: 'e2b4a7c3-6d8e-4f9e-8b2d-7c4e2a3b7d5f',
		name: 'Güter- und Personenbeförderung',
	},
	{
		id: 'f3d5a7b6-5e9a-4e7c-9b3e-2d4e6c7f8a9b',
		name: 'Handel',
	},
	{
		id: 'a7c2e4b3-6b5e-4e8a-9f2d-5e3a7b9c6d4f',
		name: 'Haus und Garten',
	},
	{
		id: 'd8e5a3b4-6c9a-4e7f-8d2e-3b6e9f5c7a2b',
		name: 'Interessensvertretung',
	},
	{
		id: 'c7b4a8d2-5e3a-4f9c-8e7b-6d2a4f5b9c8a',
		name: 'Internet',
	},
	{
		id: 'f8b2d3e4-5e7c-4e9a-8d2b-6c3a4e7b9d5a',
		name: 'Kfz, Zubehör, Kraftstoffe',
	},
	{
		id: 'd3e7a5c4-5b8a-4f9e-8d2e-7a3c4e5b9f6a',
		name: 'Körperpflege, Kosmetik',
	},
	{
		id: 'c4d2a7b3-6e8a-4f9d-8e3b-2a5e6c7f9b4a',
		name: 'Kunst und Kultur',
	},
	{
		id: 'b7e6a5d4-5c8e-4f9a-8d2b-7e3a6c4f9b5a',
		name: 'Maschinen und Werkzeuge',
	},
	{
		id: 'e5c2a7b3-6d8a-4f9e-8b2d-3a5e7c9f6b4a',
		name: 'Medien',
	},
	{
		id: 'd8a2c5b4-5e9a-4f7e-8d2b-7a6e3c4f5b9a',
		name: 'Medizinische Einrichtungen',
	},
	{
		id: 'c3e4a7b5-6d8e-4f9c-8d2b-5a7e3f6b9a2c',
		name: 'Nahrungs- und Genußmittel',
	},
	{
		id: 'e6a3b7c4-5d9e-4f8a-8d2b-7c3a5e9b6f2a',
		name: 'Optik',
	},
	{
		id: 'd4b2a7e3-6c9a-4f8e-8d2b-5e7a3f6c9b4a',
		name: 'Personalberatung, Management',
	},
	{
		id: 'e7c3a5b4-5d8e-4f9a-8b2c-6a3e4f9b7d5a',
		name: 'Pharmazeutik',
	},
	{
		id: 'd2b5a7e4-6c9a-4f8e-8d2b-7e3a6c9b4f5a',
		name: 'Politische Partei',
	},
	{
		id: 'c4e2a7b3-5d8e-4f9a-8b2c-6d3a7e9f5b4a',
		name: 'Post und Telekom',
	},
	{
		id: 'e7b2d4c3-6a9e-4f8a-8d2b-5e3a7c6f9b4a',
		name: 'Reisen',
	},
	{
		id: 'd5e3a7c4-5b8e-4f9a-8d2b-6c7a3e4f9b5a',
		name: 'Skiverbund',
	},
	{
		id: 'c3a7e4b5-6d9e-4f8a-8b2c-5e7a3d6f9b4a',
		name: 'Sonstige',
	},
	{
		id: 'e2b7a5c4-5d8e-4f9a-8d2b-6c3a7f9b5e4a',
		name: 'Sonstige Dienstleistungen',
	},
	{
		id: 'd4c2a7b3-6e9a-4f8e-8d2b-7a5e3f6b9c4a',
		name: 'Spielwaren',
	},
	{
		id: 'c5a7e3b4-5d9e-4f8a-8b2c-6d3a4f7e9b5a',
		name: 'Sportartikel',
	},
	{
		id: 'e7c2a5b3-6d8e-4f9a-8d2b-5e3a7c9f6b4a',
		name: 'Uhren, Schmuck, Foto, Optik',
	},
	{
		id: 'd5a7b4e3-6c9a-4f8e-8d2b-7a3e6f4b9c5a',
		name: 'Vereine',
	},
	{
		id: 'c4e3a7b5-5d8e-4f9a-8b2c-6a3e7f9d5b4a',
		name: 'Versandhandel',
	},
	{
		id: 'e2b7c4a3-6d9e-4f8a-8d2b-5c3a7f6b9e4a',
		name: 'Waffen',
	},
	{
		id: 'd3a7b5e4-5c9a-4f8e-8d2b-6e7a3f9b4d5a',
		name: 'Waschmittel, Putzmittel',
	},
];
